<template>
  <div class='ProdsHeader'>
    <div style="width: 4%">
      <input @change="pushAll" type="checkbox">
    </div>
    <div style="width: 8%">
      <img-icon
      text="Imagem"
      :active="true"
      :optionsLabel="{ marginTop: '65px' }"
      />
    </div>
    <div class="c-name">Nome</div>
    <div class="c-status">Status</div>
    <div style="width: 10%" class="mobile-none">{{ Empresa.modelo === 'Modelo 03' ? '' : 'Qtde' }}</div>
    <div class="c-preco">Preço</div>
    <div style="width: 10%" class="mobile-none">Categoria</div>
    <div style="width: 4%" class="mobile-none">
      <box-icon
      v-if="Empresa.modelo !== 'Modelo 03'"
      text="Tipo"
      :active="true"
      :optionsLabel="{ marginTop: '65px' }"
      />
    </div>
    <div style="width: 4%" class="mobile-none">
      <eyes-icon
      text="Visualizações"
      :active="true"
      :optionsLabel="{ marginTop: '65px' }"
      />
    </div>
    <div style="width: 10%" class="mobile-none">Data</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ImgIcon from '../../Icons/ImgIcon'
import BoxIcon from '../../Icons/BoxIcon.vue'
import EyesIcon from '../../Icons/EyesIcon.vue'
export default {
  name: 'ProdsHeader',
  components: { ImgIcon, BoxIcon, EyesIcon },
  data () {
    return {
      checked: false
    }
  },
  computed: {
    ...mapGetters(['Produtos', 'Empresa'])
  },
  methods: {
    ...mapActions(['PushAllEdit', 'ClearProdEdit']),
    pushAll () {
      this.checked = !this.checked
      if(this.checked) {
        this.PushAllEdit(this.Produtos)
      }
      if(!this.checked) {
        this.ClearProdEdit()
      }
    }
  }
}
</script>

<style scoped>
.ProdsHeader {
  height: 6%;
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  padding: 2%;
  padding-bottom: 1%;
}

.c-name {
  width: 25%;
  text-align: left;
}

.c-status {
  width: 8%;
}

.c-preco {
  width: 18%;
}

@media (max-width: 500px) {
  .mobile-none {
    display: none;
  }
  .c-name {
    width: 50%;
  }
  .c-status {
    width: 20%;
  }
  .c-preco {
    width: 20%;
  }
}
</style>
